const contenedorVideo = `
<div id="pauReactLocucionLSE" draggable="false">

    <div id="pauReactButtonBar">
        <button type="button" role="button" id="pauReactPlayVideo" title="Play / Stop" class="">||</button>
        <button type="button" role="button" id="pauReactPantallaCompleta" title="Pantalla completa" class="">[ ]</button>
        <button type="button" role="button" id="pauReactCierraVideo" title="Cerrar" class="">X</button>
    </div>
    <audio id="pauReactPageAudio" preload="auto">
    </audio>
    <video id="pauReactPageVideo" preload="auto" loop="true" style="visibility: visible;">
    </video>

</div>
`;

export default contenedorVideo;



// WEBPACK FOOTER //
// ./src/constants/contenedorVideo.js